<template>
  <div
    class="v-select-menu-with-label max-w-full"
    :class="selectStyle === 'alternative' ? 'w-auto' : 'w-full'"
  >
    <div
      class="flex items-center"
      :class="{ 'flex-col': selectStyle === 'alternative' }"
    >
      <div
        :class="[
          infoHeading || infoText ? '' : 'w-14',
          {
            'flex justify-center items-center': selectStyle === 'alternative',
          },
        ]"
      >
        <label
          :class="{
            'text-theme': themed,
            'text-black': !themed,
          }"
          class="text-xxs font-semibold uppercase truncate"
          :for="id"
          >{{ label }}</label
        >
        <ButtonInfo
          v-if="infoHeading || infoText"
          class="ml-2"
          themed
          :heading="infoHeading"
          :body="infoText"
        />
      </div>
      <v-select
        :id="id"
        v-model="selectOption"
        :data-testid="testId"
        :searchable="false"
        :clearable="false"
        :filterable="false"
        :options="options"
        :placeholder="placeholder"
        class="v-select-custom text-lg"
        :class="{
          'v-select-custom--above': openAbove,
          'v-select-custom--themed': themed,
          'v-select-custom--alt': selectStyle === 'alternative',
        }"
        :components="{ OpenIndicator }"
      />
    </div>
  </div>
</template>

<script>
import ButtonInfo from "./ButtonInfo.vue";

export default {
  name: "SelectMenuWithLabel",

  components: {
    ButtonInfo,
  },

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: Array,
    },
    placeholder: {
      type: String,
      default: "",
    },
    openAbove: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    testId: {
      type: String,
      default: null,
    },
    themed: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectStyle: {
      type: String,
      default: "default",
    },
    infoHeading: {
      type: String,
      default: null,
    },
    infoText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      OpenIndicator: {
        render: (createElement) => createElement("span", { class: "caret" }),
      },
    };
  },

  computed: {
    selectOption: {
      get() {
        return this.options.find(({ value }) => value === this.value);
      },
      set({ value }) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
